/*
  Второе действие счёта с отменённым приказом: заявление по остальным месяцам (строка 301,
  решение владельца 30.10.2026, вариант А).

  Подаётся после иска (правило строки 205: второе заявление - после завершения первого дела),
  поэтому в полосы «Ожидаем вернуть» и «Расходы на суд» оно не входит и названо отдельной
  строкой. Нет остатка долга - строки нет.
*/

import { money } from '../api/format.js'

export default function LaterAction({ verdict }) {
  if (!(Number(verdict.later_amount) > 0)) return null
  return (
    <div className="money__note">
      Затем, после иска, заявление по остальным месяцам: долг {money(verdict.later_amount)},
      ожидаем вернуть {money(verdict.later_recovery)}, пошлина {money(verdict.later_fee)}.
    </div>
  )
}
